import i18n from 'i18next';

import { ObjectInfo, ProfileRole, TaskObjectType } from '@ac/library-api';

export enum AdditionalInfoOptions {
  accountNumber = 'accountNumber',
  arAccountNumber = 'arAccountNumber',
  companyName = 'companyName',
  confirmationNumber = 'confirmationNumber',
  groupCode = 'groupCode',
  groupName = 'groupName',
  profileName = 'profileName',
  roomNumber = 'roomNumber',
  travelAgentName = 'travelAgentName'
}

function getSummariesOptions(objectInfo?: ObjectInfo): any {
  const linkedProfile = [
    {
      id: AdditionalInfoOptions.profileName,
      prefix: i18n.t('TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.PROFILE')
    },
    {
      id: AdditionalInfoOptions.companyName,
      prefix: i18n.t('TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.COMPANY')
    },
    {
      id: AdditionalInfoOptions.travelAgentName,
      prefix: i18n.t('TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.TRAVEL_AGENT')
    }
  ];

  switch (objectInfo?.type) {
    case TaskObjectType.ARAccount:
      return [
        {
          id: AdditionalInfoOptions.arAccountNumber,
          prefix: i18n.t(
            'TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.AR_ACCOUNT_NUMBER'
          )
        },
        ...linkedProfile
      ];
    case TaskObjectType.Profile: {
      if (objectInfo.profile!.role === ProfileRole.IND) {
        return [
          {
            id: AdditionalInfoOptions.profileName,
            prefix: i18n.t('TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.PROFILE')
          }
        ];
      }

      if (objectInfo.profile!.role === ProfileRole.CMP) {
        return [
          {
            id: AdditionalInfoOptions.companyName,
            prefix: i18n.t('TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.COMPANY')
          }
        ];
      }

      return [
        {
          id: AdditionalInfoOptions.travelAgentName,
          prefix: i18n.t(
            'TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.TRAVEL_AGENT'
          )
        }
      ];
    }
    case TaskObjectType.Reservation:
      return [
        {
          id: AdditionalInfoOptions.roomNumber,
          prefix: i18n.t(
            'TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.ROOM_NUMBER'
          )
        },
        {
          id: AdditionalInfoOptions.confirmationNumber,
          prefix: i18n.t(
            'TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.CONFIRMATION_NUMBER'
          )
        },
        ...linkedProfile
      ];
    case TaskObjectType.Group:
      return [
        {
          id: AdditionalInfoOptions.groupCode,
          prefix: i18n.t('TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.GROUP_CODE')
        },
        {
          id: AdditionalInfoOptions.groupName,
          prefix: i18n.t('TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.GROUP_NAME')
        },
        ...linkedProfile
      ];
    case TaskObjectType.Account:
      return [
        {
          id: AdditionalInfoOptions.accountNumber,
          prefix: i18n.t(
            'TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.ACCOUNT_NUMBER'
          )
        },
        ...linkedProfile
      ];
    case TaskObjectType.Room:
      return [
        {
          id: AdditionalInfoOptions.roomNumber,
          prefix: i18n.t(
            'TASK_MANAGEMENT.DASHBOARD.ADDITIONAL_INFO.ROOM_NUMBER'
          )
        },
        ...linkedProfile
      ];

    default:
      return [];
  }
}

export function getDetails(
  query: string = '',
  objectInfo?: ObjectInfo
): string[] {
  const { additionalInfo } = objectInfo || { additionalInfo: {} };
  const summariesOptions = getSummariesOptions(objectInfo);
  const summary = summariesOptions.find(({ id }: any) => additionalInfo?.[id]);
  const details = summariesOptions.find(
    ({ id }: any) =>
      additionalInfo?.[id] &&
      additionalInfo?.[id].toLowerCase().includes(query.toLowerCase())
  );
  const summaryPrefix = summary?.prefix || '';
  const detailsPrefix = details?.prefix || '';
  const summaryValue = additionalInfo?.[summary?.id];
  const additionalInfoValue = additionalInfo?.[details?.id];
  const dataToReturn = summaryValue ? [`${summaryPrefix}${summaryValue}`] : [];

  if (!additionalInfo || !additionalInfoValue || !query) {
    return dataToReturn;
  }

  dataToReturn.push(`${detailsPrefix}${additionalInfoValue}`);

  return dataToReturn;
}



// WEBPACK FOOTER //
// ./src/components/TaskManagement/utils/taskDetails.ts